module.exports = __webpack_public_path__ + "img/DoorbellOutlined.574c760c.svg";